<template>
  <div class="event d-flex flex-column align-items-start">
    <h4>{{ this.event_data.title }}</h4>
    <div class="icon-info">
      <div class="event-date">
        <span class="icon">
          <font-awesome icon="calendar" fixed-width />
        </span>
        <span class="info">{{ this.event_data.date_begin }}</span>
        <span
          v-if="
            this.event_data.date_end != null &&
            this.event_data.date_end != this.event_data.date_begin
          "
          class="info"
        >
          - {{ this.event_data.date_end }}</span
        >
      </div>

      <div class="event-location">
        <span class="icon">
          <font-awesome icon="map-pin" fixed-width />
        </span>
        <span class="info">{{ this.event_data.location }}</span>
      </div>
      <ul class="tag-list">
        <font-awesome
          class="icon"
          v-if="
            this.event_data.associated_projects.length != 0 ||
            this.event_data.associated_members.length != 0
          "
          icon="tags"
          fixed-width
        />
        <li
          v-for="(project, index) in this.event_data.associated_projects"
          :key="index"
        >
          <router-link :to="'/projects/' + project.project_path" tag="a">{{
            project.project_name
          }}</router-link>
        </li>
        <li
          v-for="(member, index) in this.event_data.associated_members"
          :key="index"
        >
          <router-link :to="'/members/' + member.id" tag="a">{{
            member.name
          }}</router-link>
        </li>
      </ul>
    </div>

    <p>{{ this.event_data.summary }}</p>

    <router-link :to="this.path">
      <b-button variant="primary">Read More</b-button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Event",
  props: ["event_data"],
  data() {
    return {
      path: `events/${this.event_data.id}`,
    };
  },
};
</script>

<style lang="scss">
.event {
  margin-bottom: 4em;

  .icon-info {
    .event-date,
    .event-location {
      margin-top: 0.7em;
    }

    .icon {
      margin-right: 0.7em;

      * {
        color: $secondary-color;
      }
    }

    .info {
      text-transform: uppercase;
    }

    .tag-list {
      :first-child {
        margin-top: 0.25em;
      }

      padding-left: 0;
      margin: 0;
      font-size: 1.1em;

      li {
        display: inline;
        text-transform: uppercase;

        * {
          color: $secondary-color !important;
        }

        &:not(:last-child):after {
          content: ", ";
        }
      }
    }

    p {
      margin: 1em 0 1em 0;
      text-align: justify;
    }
  }
}
</style>
